import "./styles/Catalog.css"
import catalogColumns from "./columns/catalogColumns"
import React, { FC, useEffect, useState } from "react"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { CatalogProps, Release, TableAPI } from "../../../types"
import { fetchCatalogData, selectCatalogFilter } from "../../../actions/catalogActions"
import CatalogTable from "./CatalogTable"
import CatalogFilterComponents from "./CatalogFilterComponents"
import { PERMISSIONS } from "../../../constants"
import { lang } from "../../../constants/languages"

const Catalog: FC<CatalogProps> = (props) => {
  const { selectedCatalogFilter } = props
  const [loading, setLoading] = useState(true)
  const [tableData, setTableData] = useState<Release[]>([])
  const [timeoutId, setTimeoutId] = useState(undefined)
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [search, setSearch] = useState<{ text: string; key: string }>({ text: "", key: "title" })
  const [tableAPI, setTableAPI] = useState<TableAPI | undefined>(undefined)

  const limit = 10

  const fetchReleases = async (offset: number, searchText: string, searchKey: string) => {
    await props.fetchCatalogData(
      limit,
      offset,
      props.user.id!,
      selectedCatalogFilter,
      searchKey === "title" ? searchText : undefined,
      searchKey === "upc" ? searchText : undefined,
      searchKey === "artist" ? searchText : undefined,
      searchKey === "label" ? searchText : undefined,
      searchKey === "isrc" ? searchText : undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      searchKey === "featuring" ? searchText : undefined
    )
  }

  useEffect(() => {
    const fetchSync = async () => {
      await fetchReleases(0, search.text, search.key)
    }
    fetchSync().then(() => {
      setLoading(false)
      setPageNumber(1)
      tableAPI?.setCurrentPage(1)
    })
  }, [selectedCatalogFilter])

  useEffect(() => {
    setTableData(props.paginatedReleases.results)
  }, [props.paginatedReleases])

  const onClickPage = async (pageNumber: number) => {
    setLoading(true)
    await fetchReleases((pageNumber - 1) * limit, search.text, search.key)
    setLoading(false)
    setPageNumber(pageNumber)
  }

  const onSearchRelease = (searchText: string, searchKey: string) => {
    setSearch({ text: searchText, key: searchKey })
    clearTimeout(timeoutId)
    setTimeoutId(
      // @ts-ignore
      setTimeout(async () => {
        setLoading(true)
        await fetchReleases(0, searchText, searchKey)
        setLoading(false)
        setPageNumber(1)
        tableAPI?.setCurrentPage(1)
      }, 800)
    )
  }

  return (
    <div className="catalog flex-grow mt-6">
      <CatalogTable
        title={lang.catalog.title}
        pagination
        minRowCount={limit}
        limit={limit}
        columns={catalogColumns}
        data={tableData}
        count={props.paginatedReleases.count}
        topRightElement={
          <CatalogFilterComponents
            onSearchRelease={onSearchRelease}
            newReleasePermission={props.newReleasePermission}
          />
        }
        onClickPage={onClickPage}
        setTableAPI={setTableAPI}
        rowHeightInPx={40}
        loading={loading}
      />
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user,
    paginatedReleases: state.catalogData.paginatedReleases,
    selectedCatalogFilter: state.catalogData.selectedCatalogFilter,
    newReleasePermission: state.auth.user.permissionUser?.some((item) => {
      return item.permission && item.permission.id === PERMISSIONS.NewRelease
    })
  }
}

export default connect(mapStateToProps, { fetchCatalogData, selectCatalogFilter })(Catalog)
